<template>
  <div class="admin-container">
    <el-row class="row-content">
      <el-col :span="4" class="menu-list">
        <LocalMenu :title="title" :menu-list="menuList" :active-menu="activeMenu" />
      </el-col>
      <el-col :span="20" class="main-content">
        <!-- {{ menuList }} -->
        <!-- {{ routerViewKey }} -->
        <!-- 所有级别的路由组件都在这里渲染 -->
        <router-view v-slot="{ Component }">
          <keep-alive :include="cachedViews">
            <component :is="Component" :key="routerViewKey" />
          </keep-alive>
        </router-view>
      </el-col>
    </el-row>
  </div>
</template>

<script setup>
import { computed, ref, watch } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import LocalMenu from './LocalMenu.vue'

const props = defineProps({
  title: {
    type: String,
    required: true
  },
  menuList: {
    type: Array,
    required: true
  },
  activeMenu: {
    type: String,
    default: ''
  }
})

const route = useRoute()
const router = useRouter()
const cachedViews = ref([])

// 计算当前路由的完整路径作为key，确保只显示最后一级内容
const routerViewKey = computed(() => {
  return route.fullPath
})

// 监听路由变化，添加缓存逻辑
watch(() => route.name, (toName) => {
  if (toName && !cachedViews.value.includes(toName)) {
    cachedViews.value.push(toName)
  }
}, { immediate: true })

// 获取所有路由信息（用于层级显示）
const allRoutes = computed(() => {
  return router.getRoutes().filter(route => 
    route.meta?.title && route.path !== '/' && !route.path.includes(':')
  )
})
</script>

<style lang="scss" scoped>
@use "@/styles/admin.scss";
</style>